var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -2 24 24",
    width: 48,
    height: 48,
    "aria-label": "Konsultacja",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#52d552",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 3.5,
    width: 19,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18 L9.5 15.5 L13 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11h5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.6bcfef7c8d4c546594c4269661954506.svg";
export { ForwardRef as ReactComponent };